(() => {
  const root = document.querySelector('[data-kbc-root]');
  if (!root) return;

  const pills = Array.from(root.querySelectorAll('[data-kbc-filter]'));
  const cards = Array.from(root.querySelectorAll('[data-kbc-card]'));
  const empty = root.querySelector('[data-kbc-empty]');
  const pagination = root.querySelector('[data-kbc-pagination]');
  const grid = root.querySelector('[data-kbc-grid]');
  const perPage = Math.max(1, parseInt(root.getAttribute('data-per-page') || '9', 10) || 9);

  let currentFilter = 'all';
  let currentPage = 1;

  const matchingCards = () =>
    cards.filter((card) => currentFilter === 'all' || card.getAttribute('data-category') === currentFilter);

  const renderPagination = (totalPages) => {
    if (!pagination) return;

    if (totalPages <= 1) {
      pagination.hidden = true;
      pagination.innerHTML = '';
      return;
    }

    pagination.hidden = false;

    const parts = [];
    parts.push(
      `<button type="button" class="kbc-page-btn" data-kbc-page="prev" ${
        currentPage <= 1 ? 'disabled' : ''
      } aria-label="Previous page">←</button>`
    );

    for (let i = 1; i <= totalPages; i += 1) {
      const active = i === currentPage ? ' is-active' : '';
      parts.push(
        `<button type="button" class="kbc-page-btn${active}" data-kbc-page="${i}" aria-label="Page ${i}" ${
          i === currentPage ? 'aria-current="page"' : ''
        }>${i}</button>`
      );
    }

    parts.push(
      `<button type="button" class="kbc-page-btn" data-kbc-page="next" ${
        currentPage >= totalPages ? 'disabled' : ''
      } aria-label="Next page">→</button>`
    );

    pagination.innerHTML = parts.join('');
  };

  const render = () => {
    const matched = matchingCards();
    const totalPages = Math.max(1, Math.ceil(matched.length / perPage));
    if (currentPage > totalPages) currentPage = totalPages;
    if (currentPage < 1) currentPage = 1;

    const start = (currentPage - 1) * perPage;
    const end = start + perPage;

    cards.forEach((card) => card.classList.add('is-hidden'));
    matched.forEach((card, index) => {
      card.classList.toggle('is-hidden', index < start || index >= end);
    });

    if (empty) empty.classList.toggle('is-visible', matched.length === 0);
    renderPagination(matched.length === 0 ? 0 : totalPages);
  };

  const goToPage = (page) => {
    currentPage = page;
    render();
    if (grid) {
      const top = grid.getBoundingClientRect().top + window.scrollY - 96;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  pills.forEach((pill) => {
    pill.addEventListener('click', () => {
      pills.forEach((p) => {
        p.classList.toggle('is-active', p === pill);
        p.setAttribute('aria-selected', p === pill ? 'true' : 'false');
      });
      currentFilter = pill.getAttribute('data-kbc-filter') || 'all';
      currentPage = 1;
      render();
    });
  });

  if (pagination) {
    pagination.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-kbc-page]');
      if (!btn || btn.disabled) return;

      const matched = matchingCards();
      const totalPages = Math.max(1, Math.ceil(matched.length / perPage));
      const raw = btn.getAttribute('data-kbc-page');

      if (raw === 'prev') {
        goToPage(Math.max(1, currentPage - 1));
        return;
      }
      if (raw === 'next') {
        goToPage(Math.min(totalPages, currentPage + 1));
        return;
      }

      const page = parseInt(raw, 10);
      if (!Number.isNaN(page)) goToPage(page);
    });
  }

  render();
})();
